import { render, staticRenderFns } from "./JghDetail.vue?vue&type=template&id=80566526&scoped=true"
import script from "./JghDetail.vue?vue&type=script&lang=js"
export * from "./JghDetail.vue?vue&type=script&lang=js"
import style0 from "./JghDetail.vue?vue&type=style&index=0&id=80566526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80566526",
  null
  
)

export default component.exports